import { create } from 'zustand';

interface AppState {
  token: string | null;
  refreshToken: string | null;
  /** True when an existing session was invalidated (401 + failed refresh).
   *  Drives the "please sign in again" prompt. Not set for visitors who
   *  never had a session. */
  sessionExpired: boolean;
  setAuth: (token: string | null, refreshToken: string | null) => void;
  clearAuth: () => void;
  expireSession: () => void;
  darkMode: boolean;
  toggleDarkMode: () => void;
}

export const useAppStore = create<AppState>((set, get) => ({
  // Initialized synchronously from localStorage so the very first render
  // already knows whether a session exists (no unauthenticated flash).
  token: localStorage.getItem('mc_token'),
  refreshToken: localStorage.getItem('mc_refresh_token'),
  sessionExpired: false,
  setAuth: (token, refreshToken) => {
    if (token) localStorage.setItem('mc_token', token);
    else localStorage.removeItem('mc_token');
    if (refreshToken) localStorage.setItem('mc_refresh_token', refreshToken);
    else localStorage.removeItem('mc_refresh_token');
    set({ token, refreshToken, sessionExpired: false });
  },
  clearAuth: () => {
    localStorage.removeItem('mc_token');
    localStorage.removeItem('mc_refresh_token');
    set({ token: null, refreshToken: null, sessionExpired: false });
  },
  expireSession: () => {
    const hadSession = Boolean(get().token || localStorage.getItem('mc_token'));
    localStorage.removeItem('mc_token');
    localStorage.removeItem('mc_refresh_token');
    set({ token: null, refreshToken: null, sessionExpired: hadSession });
  },
  darkMode: localStorage.getItem('mc_dark') === '1',
  toggleDarkMode: () =>
    set((state) => {
      const darkMode = !state.darkMode;
      localStorage.setItem('mc_dark', darkMode ? '1' : '0');
      return { darkMode };
    }),
}));
